import NODE10 from "@/statics/devices/Node10/header.js";
import NODE11 from "@/statics/devices/Node11/header.js";
import NODE12 from "@/statics/devices/Node12/header.js";
import NODE13 from "@/statics/devices/Node13/header.js";
import NODE14 from "@/statics/devices/Node14/header.js";
import NODE15 from "@/statics/devices/Node15/header.js";
import NODE16 from "@/statics/devices/Node16/header.js";
import NODE17 from "@/statics/devices/Node17/header.js";
import NODE18 from "@/statics/devices/Node18/header.js";
import NODE2 from "@/statics/devices/Node2/header.js";
import NODE3 from "@/statics/devices/Node3/header.js";
import NODE4 from "@/statics/devices/Node4/header.js";
import NODE5 from "@/statics/devices/Node5/header.js";
import NODE6 from "@/statics/devices/Node6/header.js";
import NODE7 from "@/statics/devices/Node7/header.js";
import NODE9 from "@/statics/devices/Node9/header.js";

const NODES_ADD_ACTIONS = {
  addNode2: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE2.INPUT1.TYPE,
          name: store.getters.language.texts[NODE2.INPUT1.NAME],
          icon: NODE2.INPUT1.ICON,
          parameterId: NODE2.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT2.TYPE,
          name: store.getters.language.texts[NODE2.INPUT2.NAME],
          icon: NODE2.INPUT2.ICON,
          parameterId: NODE2.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT3.TYPE,
          name: store.getters.language.texts[NODE2.INPUT3.NAME],
          icon: NODE2.INPUT3.ICON,
          parameterId: NODE2.INPUT3.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT4.TYPE,
          name: store.getters.language.texts[NODE2.INPUT4.NAME],
          icon: NODE2.INPUT4.ICON,
          parameterId: NODE2.INPUT4.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT5.TYPE,
          name: store.getters.language.texts[NODE2.INPUT5.NAME],
          icon: NODE2.INPUT5.ICON,
          parameterId: NODE2.INPUT5.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT6.TYPE,
          name: store.getters.language.texts[NODE2.INPUT6.NAME],
          icon: NODE2.INPUT6.ICON,
          parameterId: NODE2.INPUT6.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT7.TYPE,
          name: store.getters.language.texts[NODE2.INPUT7.NAME],
          icon: NODE2.INPUT7.ICON,
          parameterId: NODE2.INPUT7.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT8.TYPE,
          name: store.getters.language.texts[NODE2.INPUT8.NAME],
          icon: NODE2.INPUT8.ICON,
          parameterId: NODE2.INPUT8.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT9.TYPE,
          name: store.getters.language.texts[NODE2.INPUT9.NAME],
          icon: NODE2.INPUT9.ICON,
          parameterId: NODE2.INPUT9.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT10.TYPE,
          name: store.getters.language.texts[NODE2.INPUT10.NAME],
          icon: NODE2.INPUT10.ICON,
          parameterId: NODE2.INPUT10.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT11.TYPE,
          name: store.getters.language.texts[NODE2.INPUT11.NAME],
          icon: NODE2.INPUT11.ICON,
          parameterId: NODE2.INPUT11.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT12.TYPE,
          name: store.getters.language.texts[NODE2.INPUT12.NAME],
          icon: NODE2.INPUT12.ICON,
          parameterId: NODE2.INPUT12.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT13.TYPE,
          name: store.getters.language.texts[NODE2.INPUT13.NAME],
          icon: NODE2.INPUT13.ICON,
          parameterId: NODE2.INPUT13.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT14.TYPE,
          name: store.getters.language.texts[NODE2.INPUT14.NAME],
          icon: NODE2.INPUT14.ICON,
          parameterId: NODE2.INPUT14.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT15.TYPE,
          name: store.getters.language.texts[NODE2.INPUT15.NAME],
          icon: NODE2.INPUT15.ICON,
          parameterId: NODE2.INPUT15.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT16.TYPE,
          name: store.getters.language.texts[NODE2.INPUT16.NAME],
          icon: NODE2.INPUT16.ICON,
          parameterId: NODE2.INPUT16.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT17.TYPE,
          name: store.getters.language.texts[NODE2.INPUT17.NAME],
          icon: NODE2.INPUT17.ICON,
          parameterId: NODE2.INPUT17.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT18.TYPE,
          name: store.getters.language.texts[NODE2.INPUT18.NAME],
          icon: NODE2.INPUT18.ICON,
          parameterId: NODE2.INPUT18.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT19.TYPE,
          name: store.getters.language.texts[NODE2.INPUT19.NAME],
          icon: NODE2.INPUT19.ICON,
          parameterId: NODE2.INPUT19.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT20.TYPE,
          name: store.getters.language.texts[NODE2.INPUT20.NAME],
          icon: NODE2.INPUT20.ICON,
          parameterId: NODE2.INPUT20.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT21.TYPE,
          name: store.getters.language.texts[NODE2.INPUT21.NAME],
          icon: NODE2.INPUT21.ICON,
          parameterId: NODE2.INPUT21.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT22.TYPE,
          name: store.getters.language.texts[NODE2.INPUT22.NAME],
          icon: NODE2.INPUT22.ICON,
          parameterId: NODE2.INPUT22.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT23.TYPE,
          name: store.getters.language.texts[NODE2.INPUT23.NAME],
          icon: NODE2.INPUT23.ICON,
          parameterId: NODE2.INPUT23.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT24.TYPE,
          name: store.getters.language.texts[NODE2.INPUT24.NAME],
          icon: NODE2.INPUT24.ICON,
          parameterId: NODE2.INPUT24.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT25.TYPE,
          name: store.getters.language.texts[NODE2.INPUT25.NAME],
          icon: NODE2.INPUT25.ICON,
          parameterId: NODE2.INPUT25.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT26.TYPE,
          name: store.getters.language.texts[NODE2.INPUT26.NAME],
          icon: NODE2.INPUT26.ICON,
          parameterId: NODE2.INPUT26.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT27.TYPE,
          name: store.getters.language.texts[NODE2.INPUT27.NAME],
          icon: NODE2.INPUT27.ICON,
          parameterId: NODE2.INPUT27.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT28.TYPE,
          name: store.getters.language.texts[NODE2.INPUT28.NAME],
          icon: NODE2.INPUT28.ICON,
          parameterId: NODE2.INPUT28.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },

      ],
      outputs: [
        {
          type: NODE2.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT1.NAME],
          icon: NODE2.OUTPUT1.ICON,
          parameterId: NODE2.OUTPUT1.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT2.NAME],
          icon: NODE2.OUTPUT2.ICON,
          parameterId: NODE2.OUTPUT2.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT3.NAME],
          icon: NODE2.OUTPUT3.ICON,
          parameterId: NODE2.OUTPUT3.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT4.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT4.NAME],
          icon: NODE2.OUTPUT4.ICON,
          parameterId: NODE2.OUTPUT4.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT5.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT5.NAME],
          icon: NODE2.OUTPUT5.ICON,
          parameterId: NODE2.OUTPUT5.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT6.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT6.NAME],
          icon: NODE2.OUTPUT6.ICON,
          parameterId: NODE2.OUTPUT6.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT7.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT7.NAME],
          icon: NODE2.OUTPUT7.ICON,
          parameterId: NODE2.OUTPUT7.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT8.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT8.NAME],
          icon: NODE2.OUTPUT8.ICON,
          parameterId: NODE2.OUTPUT8.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT9.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT9.NAME],
          icon: NODE2.OUTPUT9.ICON,
          parameterId: NODE2.OUTPUT9.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT10.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT10.NAME],
          icon: NODE2.OUTPUT10.ICON,
          parameterId: NODE2.OUTPUT10.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT11.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT11.NAME],
          icon: NODE2.OUTPUT11.ICON,
          parameterId: NODE2.OUTPUT11.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT12.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT12.NAME],
          icon: NODE2.OUTPUT12.ICON,
          parameterId: NODE2.OUTPUT12.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT13.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT13.NAME],
          icon: NODE2.OUTPUT13.ICON,
          parameterId: NODE2.OUTPUT13.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT14.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT14.NAME],
          icon: NODE2.OUTPUT14.ICON,
          parameterId: NODE2.OUTPUT14.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT15.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT15.NAME],
          icon: NODE2.OUTPUT15.ICON,
          parameterId: NODE2.OUTPUT15.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT16.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT16.NAME],
          icon: NODE2.OUTPUT16.ICON,
          parameterId: NODE2.OUTPUT16.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT17.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT17.NAME],
          icon: NODE2.OUTPUT17.ICON,
          parameterId: NODE2.OUTPUT17.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT18.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT18.NAME],
          icon: NODE2.OUTPUT18.ICON,
          parameterId: NODE2.OUTPUT18.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT19.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT19.NAME],
          icon: NODE2.OUTPUT19.ICON,
          parameterId: NODE2.OUTPUT19.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT20.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT20.NAME],
          icon: NODE2.OUTPUT20.ICON,
          parameterId: NODE2.OUTPUT20.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT21.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT21.NAME],
          icon: NODE2.OUTPUT21.ICON,
          parameterId: NODE2.OUTPUT21.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT22.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT22.NAME],
          icon: NODE2.OUTPUT22.ICON,
          parameterId: NODE2.OUTPUT22.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT23.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT23.NAME],
          icon: NODE2.OUTPUT23.ICON,
          parameterId: NODE2.OUTPUT23.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT24.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT24.NAME],
          icon: NODE2.OUTPUT24.ICON,
          parameterId: NODE2.OUTPUT24.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT25.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT25.NAME],
          icon: NODE2.OUTPUT25.ICON,
          parameterId: NODE2.OUTPUT25.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT26.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT26.NAME],
          icon: NODE2.OUTPUT26.ICON,
          parameterId: NODE2.OUTPUT26.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT27.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT27.NAME],
          icon: NODE2.OUTPUT27.ICON,
          parameterId: NODE2.OUTPUT27.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT28.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT28.NAME],
          icon: NODE2.OUTPUT28.ICON,
          parameterId: NODE2.OUTPUT28.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT29.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT29.NAME],
          icon: NODE2.OUTPUT29.ICON,
          parameterId: NODE2.OUTPUT29.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT30.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT30.NAME],
          icon: NODE2.OUTPUT30.ICON,
          parameterId: NODE2.OUTPUT30.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT31.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT31.NAME],
          icon: NODE2.OUTPUT31.ICON,
          parameterId: NODE2.OUTPUT31.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT32.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT32.NAME],
          icon: NODE2.OUTPUT32.ICON,
          parameterId: NODE2.OUTPUT32.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT33.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT33.NAME],
          icon: NODE2.OUTPUT33.ICON,
          parameterId: NODE2.OUTPUT33.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT34.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT34.NAME],
          icon: NODE2.OUTPUT34.ICON,
          parameterId: NODE2.OUTPUT34.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT35.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT35.NAME],
          icon: NODE2.OUTPUT35.ICON,
          parameterId: NODE2.OUTPUT35.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT36.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT36.NAME],
          icon: NODE2.OUTPUT36.ICON,
          parameterId: NODE2.OUTPUT36.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT37.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT37.NAME],
          icon: NODE2.OUTPUT37.ICON,
          parameterId: NODE2.OUTPUT37.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT38.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT38.NAME],
          icon: NODE2.OUTPUT38.ICON,
          parameterId: NODE2.OUTPUT38.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT39.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT39.NAME],
          icon: NODE2.OUTPUT39.ICON,
          parameterId: NODE2.OUTPUT39.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
        {
          type: NODE2.OUTPUT40.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT40.NAME],
          icon: NODE2.OUTPUT40.ICON,
          parameterId: NODE2.OUTPUT40.PARAMETER_ID,
          settings: {
            outputType: 0,
            configured: false,
          },
        },
      ],
      // inputs: [],
      // outputs: [],
    });
  },
  addNode101: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [],
      outputs: [],
    });
  },
  // addNode3: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE3.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE3.INPUT1.NAME],
  //         icon: NODE3.INPUT1.ICON,
  //         parameterId: NODE3.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [
  //       {
  //         type: NODE3.OUTPUT1.TYPE,
  //         name: store.getters.language.texts[NODE3.OUTPUT1.NAME],
  //         icon: NODE3.OUTPUT1.ICON,
  //         parameterId: NODE3.OUTPUT1.PARAMETER_ID,
  //         initialStateParameterId: NODE3.RELAY1_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //     ],
  //   });
  //   if (nodeContex.isPaired) {
  //     store.commit("addWidget", {
  //       name: nodeContex.name,
  //       color: nodeContex.color,
  //       type: "singleSwitchWidget",
  //       hubUUID: nodeContex.hubUUID,
  //       nodeUUIDs: [nodeContex.uuid],
  //       visible: true,
  //       settings: {
  //         outputIndex: 0,
  //       },
  //     });
  //   }
  // },
  // addNode4: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE4.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE4.INPUT1.NAME],
  //         icon: NODE4.INPUT1.ICON,
  //         parameterId: NODE4.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE4.INPUT2.TYPE,
  //         name: store.getters.language.texts[NODE4.INPUT2.NAME],
  //         icon: NODE4.INPUT2.ICON,
  //         parameterId: NODE4.INPUT2.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [
  //       {
  //         type: NODE4.OUTPUT1.TYPE,
  //         name: store.getters.language.texts[NODE4.OUTPUT1.NAME],
  //         icon: NODE4.OUTPUT1.ICON,
  //         parameterId: NODE4.OUTPUT1.PARAMETER_ID,
  //         initialStateParameterId: NODE4.RELAY1_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //     ],
  //   });
  //   if (nodeContex.isPaired) {
  //     store.commit("addWidget", {
  //       name: nodeContex.name,
  //       color: nodeContex.color,
  //       type: "singleSwitchWidget",
  //       hubUUID: nodeContex.hubUUID,
  //       nodeUUIDs: [nodeContex.uuid],
  //       visible: true,
  //       settings: {
  //         outputIndex: 0,
  //       },
  //     });
  //   }
  // },
  // addNode5: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE5.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE5.INPUT1.NAME],
  //         icon: NODE5.INPUT1.ICON,
  //         parameterId: NODE5.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [
  //       {
  //         type: NODE5.OUTPUT1.TYPE,
  //         name: store.getters.language.texts[NODE5.OUTPUT1.NAME],
  //         icon: NODE5.OUTPUT1.ICON,
  //         parameterId: NODE5.OUTPUT1.PARAMETER_ID,
  //         initialStateParameterId: NODE5.RELAY1_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //     ],
  //   });
  //   if (nodeContex.isPaired) {
  //     store.commit("addWidget", {
  //       name: nodeContex.name,
  //       color: nodeContex.color,
  //       type: "singleSwitchWidget",
  //       hubUUID: nodeContex.hubUUID,
  //       nodeUUIDs: [nodeContex.uuid],
  //       visible: true,
  //       settings: {
  //         outputIndex: 0,
  //       },
  //     });
  //   }
  // },
  // addNode6: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE6.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE6.INPUT1.NAME],
  //         icon: NODE6.INPUT1.ICON,
  //         parameterId: NODE6.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE6.INPUT2.TYPE,
  //         name: store.getters.language.texts[NODE6.INPUT2.NAME],
  //         icon: NODE6.INPUT2.ICON,
  //         parameterId: NODE6.INPUT2.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [],
  //   });
  // },
  // addNode7: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE7.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE7.INPUT1.NAME],
  //         icon: NODE7.INPUT1.ICON,
  //         parameterId: NODE7.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE7.INPUT2.TYPE,
  //         name: store.getters.language.texts[NODE7.INPUT2.NAME],
  //         icon: NODE7.INPUT2.ICON,
  //         parameterId: NODE7.INPUT2.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [],
  //   });
  // },
  addNode16: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE16.INPUT1.TYPE,
          name: store.getters.language.texts[NODE16.INPUT1.NAME],
          icon: NODE16.INPUT1.ICON,
          parameterId: NODE16.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE16.INPUT2.TYPE,
          name: store.getters.language.texts[NODE16.INPUT2.NAME],
          icon: NODE16.INPUT2.ICON,
          parameterId: NODE16.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [],
    });
  },
  // addNode9: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE9.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE9.INPUT1.NAME],
  //         icon: NODE9.INPUT1.ICON,
  //         parameterId: NODE9.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [
  //       {
  //         type: NODE9.OUTPUT1.TYPE,
  //         name: store.getters.language.texts[NODE9.OUTPUT1.NAME],
  //         icon: NODE9.OUTPUT1.ICON,
  //         parameterId: NODE9.OUTPUT1.PARAMETER_ID,
  //         initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE9.OUTPUT2.TYPE,
  //         name: store.getters.language.texts[NODE9.OUTPUT2.NAME],
  //         icon: NODE9.OUTPUT2.ICON,
  //         parameterId: NODE9.OUTPUT2.PARAMETER_ID,
  //         initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE9.OUTPUT3.TYPE,
  //         name: store.getters.language.texts[NODE9.OUTPUT3.NAME],
  //         icon: NODE9.OUTPUT3.ICON,
  //         parameterId: NODE9.OUTPUT3.PARAMETER_ID,
  //         initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE9.OUTPUT4.TYPE,
  //         name: store.getters.language.texts[NODE9.OUTPUT4.NAME],
  //         icon: NODE9.OUTPUT4.ICON,
  //         parameterId: NODE9.OUTPUT4.PARAMETER_ID,
  //         initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE9.OUTPUT5.TYPE,
  //         name: store.getters.language.texts[NODE9.OUTPUT5.NAME],
  //         icon: NODE9.OUTPUT5.ICON,
  //         parameterId: NODE9.OUTPUT5.PARAMETER_ID,
  //         initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //     ],
  //   });
  // },
  // addNode10: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [],
  //     outputs: [
  //       {
  //         type: NODE10.OUTPUT1.TYPE,
  //         name: store.getters.language.texts[NODE10.OUTPUT1.NAME],
  //         icon: NODE10.OUTPUT1.ICON,
  //         parameterId: NODE10.OUTPUT1.PARAMETER_ID,
  //         initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE10.OUTPUT2.TYPE,
  //         name: store.getters.language.texts[NODE10.OUTPUT2.NAME],
  //         icon: NODE10.OUTPUT2.ICON,
  //         parameterId: NODE10.OUTPUT2.PARAMETER_ID,
  //         initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE10.OUTPUT3.TYPE,
  //         name: store.getters.language.texts[NODE10.OUTPUT3.NAME],
  //         icon: NODE10.OUTPUT3.ICON,
  //         parameterId: NODE10.OUTPUT3.PARAMETER_ID,
  //         initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE10.OUTPUT4.TYPE,
  //         name: store.getters.language.texts[NODE10.OUTPUT4.NAME],
  //         icon: NODE10.OUTPUT4.ICON,
  //         parameterId: NODE10.OUTPUT4.PARAMETER_ID,
  //         initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //     ],
  //   });
  // },
  addNode11: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE11.INPUT1.TYPE,
          name: store.getters.language.texts[NODE11.INPUT1.NAME],
          icon: NODE11.INPUT1.ICON,
          parameterId: NODE11.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE11.LEDSTATE1.TYPE,
          name: store.getters.language.texts[NODE11.LEDSTATE1.NAME],
          icon: NODE11.LEDSTATE1.ICON,
          parameterId: NODE11.LEDSTATE1.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE11.LEDSTATE1.TYPE,
          name: store.getters.language.texts[NODE11.LEDSTATE1.NAME],
          icon: NODE11.LEDSTATE1.ICON,
          parameterId: NODE11.LEDSTATE1.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE11.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE11.OUTPUT1.NAME],
          icon: NODE11.OUTPUT1.ICON,
          parameterId: NODE11.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE11.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
      settings: {
        switches: [
        {
          name: store.getters.language.texts.AddNewWidget_autoThreeWay_SwitchName3,
          index: 0,
        }]
      },
    });
  },
  addNode12: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      settings: {
        switches: [
        {
          name: store.getters.language.texts.AddNewWidget_autoThreeWay_SwitchName2,
          index: 1,
        },
        {
          name: store.getters.language.texts.AddNewWidget_autoThreeWay_SwitchName3,
          index: 0,
        }]
      },

      inputs: [
        {
          type: NODE12.INPUT1.TYPE,
          name: store.getters.language.texts[NODE12.INPUT1.NAME],
          icon: NODE12.INPUT1.ICON,
          parameterId: NODE12.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE12.INPUT2.TYPE,
          name: store.getters.language.texts[NODE12.INPUT2.NAME],
          icon: NODE12.INPUT2.ICON,
          parameterId: NODE12.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE12.LEDSTATE1.TYPE,
          name: store.getters.language.texts[NODE12.LEDSTATE1.NAME],
          icon: NODE12.LEDSTATE1.ICON,
          parameterId: NODE12.LEDSTATE1.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE12.LEDSTATE2.TYPE,
          name: store.getters.language.texts[NODE12.LEDSTATE2.NAME],
          icon: NODE12.LEDSTATE2.ICON,
          parameterId: NODE12.LEDSTATE2.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE12.LEDSTATE1.TYPE,
          name: store.getters.language.texts[NODE12.LEDSTATE1.NAME],
          icon: NODE12.LEDSTATE1.ICON,
          parameterId: NODE12.LEDSTATE1.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE12.LEDSTATE2.TYPE,
          name: store.getters.language.texts[NODE12.LEDSTATE2.NAME],
          icon: NODE12.LEDSTATE2.ICON,
          parameterId: NODE12.LEDSTATE2.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE12.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE12.OUTPUT1.NAME],
          icon: NODE12.OUTPUT1.ICON,
          parameterId: NODE12.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE12.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE12.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE12.OUTPUT2.NAME],
          icon: NODE12.OUTPUT2.ICON,
          parameterId: NODE12.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE12.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ]
    });
  },
  addNode13: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      settings: {
        switches: [{
          name: store.getters.language.texts.AddNewWidget_autoThreeWay_SwitchName1,
          index: 2,
        },
        {
          name: store.getters.language.texts.AddNewWidget_autoThreeWay_SwitchName2,
          index: 1,
        },
        {
          name: store.getters.language.texts.AddNewWidget_autoThreeWay_SwitchName3,
          index: 0,
        }]
      },
            inputs: [
        {
          type: NODE13.INPUT1.TYPE,
          name: store.getters.language.texts[NODE13.INPUT1.NAME],
          icon: NODE13.INPUT1.ICON,
          parameterId: NODE13.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE13.INPUT2.TYPE,
          name: store.getters.language.texts[NODE13.INPUT2.NAME],
          icon: NODE13.INPUT2.ICON,
          parameterId: NODE13.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE13.INPUT3.TYPE,
          name: store.getters.language.texts[NODE13.INPUT3.NAME],
          icon: NODE13.INPUT3.ICON,
          parameterId: NODE13.INPUT3.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE13.LEDSTATE1.TYPE,
          name: store.getters.language.texts[NODE13.LEDSTATE1.NAME],
          icon: NODE13.LEDSTATE1.ICON,
          parameterId: NODE13.LEDSTATE1.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.LEDSTATE2.TYPE,
          name: store.getters.language.texts[NODE13.LEDSTATE2.NAME],
          icon: NODE13.LEDSTATE2.ICON,
          parameterId: NODE13.LEDSTATE2.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.LEDSTATE3.TYPE,
          name: store.getters.language.texts[NODE13.LEDSTATE3.NAME],
          icon: NODE13.LEDSTATE3.ICON,
          parameterId: NODE13.LEDSTATE3.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],

      outputs: [
        {
          type: NODE13.LEDSTATE1.TYPE,
          name: store.getters.language.texts[NODE13.LEDSTATE1.NAME],
          icon: NODE13.LEDSTATE1.ICON,
          parameterId: NODE13.LEDSTATE1.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.LEDSTATE2.TYPE,
          name: store.getters.language.texts[NODE13.LEDSTATE2.NAME],
          icon: NODE13.LEDSTATE2.ICON,
          parameterId: NODE13.LEDSTATE2.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.LEDSTATE3.TYPE,
          name: store.getters.language.texts[NODE13.LEDSTATE3.NAME],
          icon: NODE13.LEDSTATE3.ICON,
          parameterId: NODE13.LEDSTATE3.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT1.NAME],
          icon: NODE13.OUTPUT1.ICON,
          parameterId: NODE13.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE13.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT2.NAME],
          icon: NODE13.OUTPUT2.ICON,
          parameterId: NODE13.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE13.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT3.NAME],
          icon: NODE13.OUTPUT3.ICON,
          parameterId: NODE13.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE13.RELAY3_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ]
    });
  },
  addNode14: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE14.INPUT1.TYPE,
          name: store.getters.language.texts[NODE14.INPUT1.NAME],
          icon: NODE14.INPUT1.ICON,
          parameterId: NODE14.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE14.INPUT2.TYPE,
          name: store.getters.language.texts[NODE14.INPUT2.NAME],
          icon: NODE14.INPUT2.ICON,
          parameterId: NODE14.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE14.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE14.OUTPUT1.NAME],
          icon: NODE14.OUTPUT1.ICON,
          parameterId: NODE14.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE14.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    // TODO: check here if the switch widget needs to be changed
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name,
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
    }
  },
  addNode15: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE15.INPUT1.TYPE,
          name: store.getters.language.texts[NODE15.INPUT1.NAME],
          icon: NODE15.INPUT1.ICON,
          parameterId: NODE15.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        }
      ],
      outputs: [
        {
          type: NODE15.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE15.OUTPUT1.NAME],
          icon: NODE15.OUTPUT1.ICON,
          parameterId: NODE15.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE15.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        }
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name + "-1",
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
     
    }
  },
  // addNode18: function (store, nodeContex) {
  //   store.commit("addNode", {
  //     name: nodeContex.name,
  //     color: nodeContex.color,
  //     uuid: nodeContex.uuid,
  //     hubUUID: nodeContex.hubUUID,
  //     deviceType: nodeContex.deviceType,
  //     firmwareYear: nodeContex.firmwareYear,
  //     firmwareMonth: nodeContex.firmwareMonth,
  //     isPaired: nodeContex.isPaired,
  //     connectionStatus: -1,
  //     rawParameters: [],
  //     inputs: [
  //       {
  //         type: NODE18.INPUT1.TYPE,
  //         name: store.getters.language.texts[NODE18.INPUT1.NAME],
  //         icon: NODE18.INPUT1.ICON,
  //         parameterId: NODE18.INPUT1.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE18.INPUT2.TYPE,
  //         name: store.getters.language.texts[NODE18.INPUT2.NAME],
  //         icon: NODE18.INPUT2.ICON,
  //         parameterId: NODE18.INPUT2.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE18.INPUT3.TYPE,
  //         name: store.getters.language.texts[NODE18.INPUT3.NAME],
  //         icon: NODE18.INPUT3.ICON,
  //         parameterId: NODE18.INPUT3.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE18.INPUT4.TYPE,
  //         name: store.getters.language.texts[NODE18.INPUT4.NAME],
  //         icon: NODE18.INPUT4.ICON,
  //         parameterId: NODE18.INPUT4.PARAMETER_ID,
  //         settings: {
  //           inputType: 0,
  //         },
  //       },
  //     ],
  //     outputs: [
  //       {
  //         type: NODE18.OUTPUT1.TYPE,
  //         name: store.getters.language.texts[NODE18.OUTPUT1.NAME],
  //         icon: NODE18.OUTPUT1.ICON,
  //         parameterId: NODE18.OUTPUT1.PARAMETER_ID,
  //         initialStateParameterId: NODE18.RELAY1_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE18.OUTPUT2.TYPE,
  //         name: store.getters.language.texts[NODE18.OUTPUT2.NAME],
  //         icon: NODE18.OUTPUT2.ICON,
  //         parameterId: NODE18.OUTPUT2.PARAMETER_ID,
  //         initialStateParameterId: NODE18.RELAY2_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE18.OUTPUT3.TYPE,
  //         name: store.getters.language.texts[NODE18.OUTPUT3.NAME],
  //         icon: NODE18.OUTPUT3.ICON,
  //         parameterId: NODE18.OUTPUT3.PARAMETER_ID,
  //         initialStateParameterId: NODE18.RELAY2_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //       {
  //         type: NODE18.OUTPUT4.TYPE,
  //         name: store.getters.language.texts[NODE18.OUTPUT4.NAME],
  //         icon: NODE18.OUTPUT4.ICON,
  //         parameterId: NODE18.OUTPUT4.PARAMETER_ID,
  //         initialStateParameterId: NODE18.RELAY2_INIT.PARAMETER_ID,
  //         settings: {
  //           outputType: 0,
  //         },
  //       },
  //     ],
  //   });
  //   if (nodeContex.isPaired) {
  //     for (let i = 0; i < 4; i++) {
  //       store.commit("addWidget", {
  //         name: nodeContex.name + `-${i + 1}`,
  //         color: nodeContex.color,
  //         type: "singleSwitchWidget",
  //         hubUUID: nodeContex.hubUUID,
  //         nodeUUIDs: [nodeContex.uuid],
  //         visible: true,
  //         settings: {
  //           outputIndex: i,
  //         },
  //       });
  //     }
  //   }
  // },
  addNode17: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE17.INPUT1.TYPE,
          name: store.getters.language.texts[NODE17.INPUT1.NAME],
          icon: NODE17.INPUT1.ICON,
          parameterId: NODE17.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE17.INPUT2.TYPE,
          name: store.getters.language.texts[NODE17.INPUT2.NAME],
          icon: NODE17.INPUT2.ICON,
          parameterId: NODE17.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE17.INPUT3.TYPE,
          name: store.getters.language.texts[NODE17.INPUT3.NAME],
          icon: NODE17.INPUT3.ICON,
          parameterId: NODE17.INPUT3.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        }
      ],
      outputs: [
        {
          type: NODE17.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE17.OUTPUT1.NAME],
          icon: NODE17.OUTPUT1.ICON,
          parameterId: NODE17.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE17.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE17.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE17.OUTPUT2.NAME],
          icon: NODE17.OUTPUT2.ICON,
          parameterId: NODE17.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE17.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE17.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE17.OUTPUT3.NAME],
          icon: NODE17.OUTPUT3.ICON,
          parameterId: NODE17.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE17.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        }
      ],
    });
    if (nodeContex.isPaired) {
      for (let i = 0; i < 3; i++) {
        store.commit("addWidget", {
          name: nodeContex.name + `-${i + 1}`,
          color: nodeContex.color,
          type: "singleSwitchWidget",
          hubUUID: nodeContex.hubUUID,
          nodeUUIDs: [nodeContex.uuid],
          visible: true,
          settings: {
            outputIndex: i,
          },
        });
      }
    }
  },
};
export default NODES_ADD_ACTIONS;
